import { Button, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import React from "react";
import { HiSearch } from "react-icons/hi";
import { SearchFilters } from "src/model/SearchFilters";
import { setSimpleSearch } from "src/state/search/searchSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

export default function SimpleSearch(props: {
  onSubmit(searchFilters: SearchFilters): void;
}) {
  const dispatch = useAppDispatch();
  const searchState = useAppSelector((state) => state.search);

  const form = useForm({
    mode: "controlled",
    initialValues: {
      search: searchState.simpleSearch ?? "",
    },

    validate: (values) => {
      return {
        name:
          values.search.trim().length < 3
            ? "Search must include at least 3 characters"
            : null,
      };
    },
  });

  const onSubmit = () => {
    form.validate();

    if (!form.isValid()) return;

    dispatch(setSimpleSearch(form.values.search));

    props.onSubmit({
      simpleSearch: form.values.search,
    });
  };

  return (
    <div className="flex flex-col w-full h-full justify-center p-4 max-w-[700px] m-auto gap-4">
      <TextInput
        leftSectionPointerEvents="none"
        leftSection={<HiSearch />}
        placeholder="Search by folder, file, location, date..."
        defaultValue={searchState.simpleSearch ?? ""}
        {...form.getInputProps("search")}
      />

      <Button
        className=""
        leftSection={<HiSearch />}
        onClick={onSubmit}
        disabled={!form.isValid()}
      >
        Search
      </Button>
    </div>
  );
}
